import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "LiquidityGAP" })((_theme) => ({
  page: {
    margin: "20px",
  },
  liquidityGAPExportBtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: "10px",
    marginTop: "-30px",
  },
}));
